module.exports = __webpack_public_path__ + "static/sport/img-swiper2.9746f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/img-swiper2.png
// module id = y4fM
// module chunks = 0